// extracted by mini-css-extract-plugin
export default {"filled":"StarRatring_filled__YeVJw","HalfStar":"StarRatring_HalfStar__GGfYT","emptyStar":"StarRatring_emptyStar__hMJbN","starsDiv":"StarRatring_starsDiv__Wpo8m"};